import { AlignType } from 'common/types/styleTypes'
import {
  FontPropsTransient,
  fontCssTransient,
  lineHeightCssTransient,
  mobileFontCssTransient,
  mobileLineHeightCssTransient,
} from 'common/utils/styleUtilsNew'
import styled, { css } from 'styled-components'

type BlogPostTitleUiNewProps = {
  $lineHeight?: number
  $mobileLineHeight?: number
  $alignSelf: AlignType
  $mobileAlignSelf?: AlignType
} & FontPropsTransient

const BlogPostTitleUiNew = styled.h1<BlogPostTitleUiNewProps>`
  text-align: ${p => p.$alignSelf || 'center'};
  ${fontCssTransient}
  ${p => p.$fontFamily && `font-family: ${p.$fontFamily} !important;`}
  ${lineHeightCssTransient}

${p => p.theme.phone} {
    text-align: ${p => p.$mobileAlignSelf || 'center'};
    ${mobileFontCssTransient}
    ${p =>
      p.$mobileFontFamily && `font-family: ${p.$mobileFontFamily} !important;`}
    ${mobileLineHeightCssTransient}
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobileFontCssTransient}
      ${
        p.$mobileFontFamily && `font-family: ${p.$mobileFontFamily} !important;`
      }
      ${mobileLineHeightCssTransient}
      text-align: ${p.$mobileAlignSelf || 'center'};
    `}
`

export default BlogPostTitleUiNew
